<template>
    <div class="base-mit-app-navigation">
          <v-navigation-drawer app permanent clipped>
            <MitMenu v-if="userModel" :userModel="userModel" :userRoles="userRoles" v-on:logout="logout" v-on:login="login"/>
          </v-navigation-drawer>
      </div>
</template>

<script>
import MitMenu from './BaseMitMenu.vue';

export default {
  name: 'BaseMitAppNavigation',
  components: {
    MitMenu
  },
  props: {
    userModel: Object,
    userRoles: Object
  },
  data: function() {
    return {
    }
  },
  methods : {
        login(){
          this.$emit('login');
        },
        logout: function() {
          this.$emit('logout');
        }
  }
}
</script>

<style lang="scss" scoped>
</style>
